import { type CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import type { FC } from 'react';

import { typographyVariants } from '@mint-lib/tw-components';
import { Link } from '@mint/routing';

import type { ApprovalTableItemData } from '../../../types/approversTable.js';

type Props = CustomCellRendererProps<ApprovalTableItemData, string>;

const NameCell: FC<Props> = ({ value, data }) => {
  if (!value || !data?.id) {
    return null;
  }

  return (
    <Link
      className={typographyVariants({ variant: 'bodyShort02', color: 'link' })}
      data-dd-action-name="Navigate to the flow page"
      to="/company-profile/flows/$flowId"
      params={{
        flowId: data.id,
      }}
    >
      {value}
    </Link>
  );
};

export default NameCell;
